import { cn } from "../lib/utils";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "./alert-dialog";

type ConfirmDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel?: () => void;
  loading?: boolean;
  destructive?: boolean;
  cancelClassName?: string;
  confirmClassName?: string;
};

export function CustomConfirmDialog({
  open,
  onOpenChange,
  title,
  description,
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
  loading = false,
  destructive = false,
  cancelClassName,
  confirmClassName,
}: ConfirmDialogProps) {
  const handleCancel = () => {
    onOpenChange(false);
    if (onCancel) onCancel();
  };
  return (
    <AlertDialog open={open} onOpenChange={loading ? undefined : onOpenChange}>
      <AlertDialogContent className="w-[80%] sm:w-full rounded-lg">
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>

          {description && (
            <AlertDialogDescription>{description}</AlertDialogDescription>
          )}
        </AlertDialogHeader>

        <AlertDialogFooter className="flex flex-row justify-end gap-2">
          <AlertDialogCancel
            onClick={handleCancel}
            disabled={loading}
            className={cn("mt-0 flex-1 sm:flex-none sm:w-1/2", cancelClassName)}
          >
            {cancelText}
          </AlertDialogCancel>

          <AlertDialogAction
            onClick={(e) => {
              e.preventDefault();
              onConfirm();
            }}
            disabled={loading}
            className={cn(
              "flex-1 sm:flex-none sm:w-1/2",
              confirmClassName,
              destructive &&
                "bg-destructive hover:bg-destructive/90 text-white",
            )}
          >
            {loading ? "Please wait..." : confirmText}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
